import React from 'react';
import { injectIntl } from 'react-intl';
import { convertObjectToArray, formatNumber, detectIfBracketHasImages, affect_color_filter, getRoundLabel, isColorBright, RGB_2_HEX } from '../../../lib/ep.js';

import FloatingLayerPublic from '../../front/FloatingLayerPublic';

let black_color = 'rgba(0, 0, 0, 1)';

const RoundVotesLayer = (props) => {
	let bracket = (props.bracket != undefined) ? props.bracket : false;
	const _matches = (props.matches_results != undefined) ? props.matches_results : false;
	const teams = (props.teams != undefined) ? props.teams : false;
	if(!bracket || !_matches || !teams) return null;

	const round = (props.round != undefined) ? props.round : 1;
	const main_color = props.main_color;
	const loser_color = affect_color_filter(0.7, black_color);

	let _has_images = detectIfBracketHasImages(teams);
	let has_images = (_has_images.images > 0 || _has_images.bg_color > 0) ? true : false;
	let is_builder = (props.is_builder != undefined) ? props.is_builder : false;

	const matches_arr = convertObjectToArray(_matches);
	const matches = matches_arr.filter((obj) => { return obj.round == round; });

	const autoflip_candidates = (bracket.autoflip_candidates != undefined && bracket.autoflip_candidates == '1') ? true : false;

	return (
		<FloatingLayerPublic
			pm={props.promotion}
			title={`<h1>${props.intl.formatMessage({id:"Voting stats for {round}"}, { round:getRoundLabel(bracket, round, false, props.intl) })}</h1>`}
			is_builder={is_builder}
			backButton={() => props.backButton()}
		>
			<div>
				<ul class={'candidates_votes_stats' + ((!has_images) ? ' without_images' : '')}>
					{matches.map((match, m) => {
						let match_ref = match.key.split("_");
						let candidateA = teams.find((obj) => { return obj.id == match_ref[1]; });
						let candidateB = teams.find((obj) => { return obj.id == match_ref[2]; });

						let votesA = parseInt(match.votes[0]);
						let votesB = parseInt(match.votes[1]);

						let total_votes_in_match = votesA + votesB;
						let percentA = 100 * votesA / total_votes_in_match;
						let percentB = (true) ? (100 - percentA) : (100 * votesB / total_votes_in_match);

						let winner = (percentA != percentB) ? ((votesA > votesB) ? 0 : 1) : ((match.winner == match_ref[1]) ? 0 : 1);

						let colorA = (winner === 0) ? main_color : loser_color;
						let colorB = (winner === 1) ? main_color : loser_color;

						let textColorA = (isColorBright(RGB_2_HEX(colorA))) ? 'is_bright' : 'is_dark';
						let textColorB = (isColorBright(RGB_2_HEX(colorB))) ? 'is_bright' : 'is_dark';

						let teamA_bg_styles = null;
						let teamB_bg_styles = null;
						if(has_images) {
							teamA_bg_styles = {};

							teamA_bg_styles.borderColor = colorA;

							if(candidateA.full_thumb_image != undefined && candidateA.full_thumb_image != "") {
								teamA_bg_styles.backgroundImage = 'url(' + candidateA.full_thumb_image + ')';
							}

							if(teamA_bg_styles.backgroundImage == undefined && candidateA.full_image != undefined && candidateA.full_image != "") {
								teamA_bg_styles.backgroundImage = 'url(' + candidateA.full_image + ')';
							}

							if(candidateA.color != undefined && candidateA.color != "") {
								teamA_bg_styles.backgroundColor = candidateA.color;
							}

							teamB_bg_styles = {};

							teamB_bg_styles.borderColor = colorB;

							if(candidateB.full_thumb_image != undefined && candidateB.full_thumb_image != "") {
								teamB_bg_styles.backgroundImage = 'url(' + candidateB.full_thumb_image + ')';
							}

							if(teamB_bg_styles.backgroundImage == undefined && candidateB.full_image != undefined && candidateB.full_image != "") {
								teamB_bg_styles.backgroundImage = 'url(' + candidateB.full_image + ')';
							}

							if(candidateB.color != undefined && candidateB.color != "") {
								teamB_bg_styles.backgroundColor = candidateB.color;
							}
						}

						return (
							<li key={`votes_match_${m}`}>
								<span class="candidate candidateA" style={{background:colorA}}>
									{(has_images) && (
										<span class="img" style={teamA_bg_styles}>
											<img src="/img/blank_1x1.png" height="100%" alt={candidateA.name} />
										</span>
									)}

									<span class={'textual_info ' + textColorA}>
										<span class="name gui_cutTextOnOverflow">
											<strong class="original_color_item">{candidateA.name}</strong>
										</span>
										<span class="votes original_color_item"><span class="total">{votesA}</span> <span class="gui_only_wide_screen original_color_item">({formatNumber(percentA, 2)}%)</span></span>
									</span>
								</span>

								<div class="stat_bars">
									<span>
										<span style={{background:colorA, flexBasis:percentA + '%'}} />
										<span style={{background:colorB, flexBasis:percentB + '%'}} />
									</span>
								</div>

								<span class="candidate candidateB" style={{background:colorB}}>
									{(has_images) && (
										<span class={'img' + ((autoflip_candidates) ? ' is_flipped' : '')} style={teamB_bg_styles}>
											<img src="/img/blank_1x1.png" height="100%" alt={candidateB.name} />
										</span>
									)}

									<span class={'textual_info ' + textColorB}>
										<span class="name gui_cutTextOnOverflow">
											<strong class="original_color_item">{candidateB.name}</strong>
										</span>
										<span class="votes original_color_item"><span class="total">{votesB}</span> <span class="gui_only_wide_screen original_color_item">({formatNumber(percentB, 2)}%)</span></span>
									</span>
								</span>
							</li>
						)
					})}
				</ul>
			</div>
		</FloatingLayerPublic>
	)
};

export default injectIntl(RoundVotesLayer);